import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';

@Injectable()
export class DepartTimeService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  create(departtime: any) {
    return this.authHttp.post('/api/departs/', departtime).map(res => {
      return { 'status': res.status, 'value': res.json() };
    });
  }

  getAllDepartTimes() {
    return this.http.get('/api/departs/').map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete('/api/departs/' + id).map(res => res.json());
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/depart-time.service.ts